import { Pages } from '.generated/Project.CW.model';
import type { WithContext, MedicalWebPage } from 'schema-dts';
import { stripHtmlTags } from 'lib/utils/string-utils';

export const buildTreatmentPageJsonLd = (
  data: Pages.ConditionOrTreatment,
  pageUrl: string
): WithContext<MedicalWebPage> => ({
  '@context': 'https://schema.org',
  '@type': 'MedicalWebPage',
  name: data.fields?.Title?.value,
  description: stripHtmlTags(data.fields?.Description?.value),
  url: pageUrl,
});
